enum GitErrorCode {
	HealthcheckFailed = "HealthcheckFailed",
	RemoteRepositoryNotFoundError = "RemoteRepositoryNotFoundError",
	ContentTooLargeError = "ContentTooLargeError",
	NotAuthorizedError = "NotAuthorizedError",
	CurrentBranchNotFoundError = "CurrentBranchNotFoundError",
	NetworkConntectionError = "NetworkConntectionError",
	MergeNotSupportedError = "MergeNotSupportedError",
	CantGetConflictedFiles = "CantGetConflictedFiles",
	CheckoutConflictError = "CheckoutConflictError",
	DeleteCurrentBranch = "DeleteCurrentBranch",
	MergeConflictError = "MergeConflictError",
	AlreadyExistsError = "AlreadyExistsError",
	WorkingDirNotEmpty = "WorkingDirNotEmpty",
	PushRejectedError = "PushRejectedError",
	NotFoundError = "NotFoundError",
	GitPushError = "GitPushError",
	CloneError = "CloneError",
	MergeError = "MergeError",
	HttpError = "HttpError",
	FileNotFoundError = "FileNotFoundError",
	CancelledOperation = "CancelledOperation",
	NotEnoughDiskSpace = "NotEnoughDiskSpace",
}

export default GitErrorCode;
